import React from "react";
import "./sectionWhiteLabel.scss";

//Imagens:
import ImgSectionWhiteLabel from "../../../../assets/whiteLabel/sectionWhiteLabel.png";
import { t } from "i18next";

function SectionWhiteLabel() {
  return (
    <div className="container-section-white-label">
      <div className="img-section-white-label">
        <img src={ImgSectionWhiteLabel} alt="" />
      </div>
      <div className="texts-section-white-label">
        <h1>{t("whitelabel.title")}</h1>
        <p>{t("whitelabel.section_text")}</p>
        <a href="/form" style={{ textDecoration: "none" }}>
          <button id="btn-section-white-label">{t("buttons.demo_btn_alternative_text_1")}</button>
        </a>
      </div>
    </div>
  );
}

export default SectionWhiteLabel;
